<script setup lang="ts">
    import { AgentChannel, AgentType } from 'models'
    import PkCheckboxField from '../PkCheckboxField.vue'
    import { computed } from 'vue'
    import PkFieldset from '../PkFieldset.vue'

    const props = defineProps<{
        type?: AgentType | string
    }>()

    const channels = defineModel<AgentChannel[]>({
        default: () => Object.values(AgentChannel),
    })

    const isChatAgent = computed(() => props.type === AgentType.Chat)

    function isEnabled(channel: AgentChannel): boolean {
        return channels.value.includes(channel)
    }

    function toggle(channel: AgentChannel, enabled: boolean): void {
        if (enabled) {
            channels.value = [...channels.value, channel]
        } else {
            channels.value = channels.value.filter((c) => c !== channel)
        }
    }
</script>

<template>
    <PkFieldset :legend="$t('label.channels')">
        <PkCheckboxField
            :model-value="isEnabled(AgentChannel.Frontoffice)"
            name="channel.frontoffice"
            switch
            :label="$t('agent.channel.frontoffice')"
            :hint-label="$t('hint.channel.frontoffice')"
            @update:model-value="
                (val: boolean) => toggle(AgentChannel.Frontoffice, val)
            " />
        <PkCheckboxField
            v-if="isChatAgent"
            :model-value="isEnabled(AgentChannel.App)"
            name="channel.app"
            switch
            :label="$t('agent.channel.app')"
            :hint-label="$t('hint.channel.app')"
            @update:model-value="
                (val: boolean) => toggle(AgentChannel.App, val)
            " />
        <PkCheckboxField
            v-if="isChatAgent"
            :model-value="isEnabled(AgentChannel.Widget)"
            name="channel.widget"
            switch
            class="mb-0"
            :label="$t('agent.channel.widget')"
            :hint-label="$t('hint.channel.widget')"
            @update:model-value="
                (val: boolean) => toggle(AgentChannel.Widget, val)
            " />
    </PkFieldset>
</template>
